// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialHistory-module__font-s-10___Zev0b {
  font-size: 10px !important;
}

.SocialHistory-module__font-s-12___jcqRU {
  font-size: 12px !important;
}

.SocialHistory-module__font-s-13___p7ouF {
  font-size: 13px !important;
}

.SocialHistory-module__font-s-14___eawHq {
  font-size: 14px !important;
}

.SocialHistory-module__font-s-15___W0Qxf {
  font-size: 15px !important;
}

.SocialHistory-module__font-s-16___AdtiL {
  font-size: 16px !important;
}

.SocialHistory-module__font-s-18___N3Iwv {
  font-size: 18px !important;
}

.SocialHistory-module__font-s-20___R0v2K {
  font-size: 20px !important;
}

.SocialHistory-module__font-s-22___zFo1M {
  font-size: 22px !important;
}

.SocialHistory-module__font-s-28___d4XMZ {
  font-size: 28px !important;
}

.SocialHistory-module__font-w-400___PJq7H {
  font-weight: 400 !important;
}

.SocialHistory-module__font-w-500___dUeXe {
  font-weight: 500 !important;
}

.SocialHistory-module__font-w-600___OPY9C {
  font-weight: 600 !important;
}

.SocialHistory-module__font-w-700___rcks4 {
  font-weight: 700 !important;
}

.SocialHistory-module__p-5___FakV9 {
  padding: 5px !important;
}

.SocialHistory-module__p-12___AUps8 {
  padding: 12px !important;
}

.SocialHistory-module__p-16___RTLFt {
  padding: 16px !important;
}

.SocialHistory-module__p-30___wrdiN {
  padding: 30px !important;
}

.SocialHistory-module__p-b-0___fy6Av {
  padding-bottom: 0 !important;
}

.SocialHistory-module__p-b-5___dWDxD {
  padding-bottom: 5px !important;
}

.SocialHistory-module__p-b-10___cewEV {
  padding-bottom: 10px !important;
}

.SocialHistory-module__p-b-12___NCCgQ {
  padding-bottom: 12px !important;
}

.SocialHistory-module__p-b-16___o4DF9 {
  padding-bottom: 16px !important;
}

.SocialHistory-module__p-b-18___ApFmU {
  padding-bottom: 18px !important;
}

.SocialHistory-module__p-b-20___TtpF0 {
  padding-bottom: 20px !important;
}

.SocialHistory-module__p-b-25___DON2T {
  padding-bottom: 25px !important;
}

.SocialHistory-module__p-b-30___XBaS2 {
  padding-bottom: 30px !important;
}

.SocialHistory-module__p-b-50___q4fXa {
  padding-bottom: 50px !important;
}

.SocialHistory-module__p-t-0____OvOA {
  padding-top: 0 !important;
}

.SocialHistory-module__p-t-12___NKslD {
  padding-top: 12px !important;
}

.SocialHistory-module__p-t-16___fx55a {
  padding-top: 16px !important;
}

.SocialHistory-module__p-t-18___kZVPt {
  padding-top: 18px !important;
}

.SocialHistory-module__p-t-20___DJKkW {
  padding-top: 20px !important;
}

.SocialHistory-module__p-t-30___j8iBq {
  padding-top: 30px !important;
}

.SocialHistory-module__p-t-40___elYLN {
  padding-top: 40px !important;
}

.SocialHistory-module__p-t-50___rbcBV {
  padding-top: 50px !important;
}

.SocialHistory-module__p-l-20___SidPz {
  padding-left: 20px !important;
}

.SocialHistory-module__p-l-30___ODQgF {
  padding-left: 30px !important;
}

.SocialHistory-module__p-l-40___KToLT {
  padding-left: 40px !important;
}

.SocialHistory-module__p-r-16___CguAf {
  padding-right: 16px !important;
}

.SocialHistory-module__p-r-20___IQS84 {
  padding-right: 20px !important;
}

.SocialHistory-module__p-r-30___y_dIU {
  padding-right: 30px !important;
}

.SocialHistory-module__p-r-50___PCuf1 {
  padding-right: 50px !important;
}

.SocialHistory-module__p-r-60___Yneof {
  padding-right: 60px !important;
}

.SocialHistory-module__m-b-1___JaHwO {
  margin-bottom: 1px !important;
}

.SocialHistory-module__m-b-2___teU17 {
  margin-bottom: 2px !important;
}

.SocialHistory-module__m-b-6___FhGCc {
  margin-bottom: 6px !important;
}

.SocialHistory-module__m-b-8___kxBKj {
  margin-bottom: 8px !important;
}

.SocialHistory-module__m-b-10___vy7E2 {
  margin-bottom: 10px !important;
}

.SocialHistory-module__m-b-14___aA2u3 {
  margin-bottom: 14px !important;
}

.SocialHistory-module__m-b-16___rwlcE {
  margin-bottom: 16px !important;
}

.SocialHistory-module__m-b-20___YLFqu {
  margin-bottom: 20px !important;
}

.SocialHistory-module__m-b-22___bmI5W {
  margin-bottom: 22px !important;
}

.SocialHistory-module__m-b-24___VQAee {
  margin-bottom: 24px !important;
}

.SocialHistory-module__m-b-30___XjZOM {
  margin-bottom: 30px !important;
}

.SocialHistory-module__m-b-32___Nb0eY {
  margin-bottom: 32px !important;
}

.SocialHistory-module__m-b-40___AdX3F {
  margin-bottom: 40px !important;
}

.SocialHistory-module__m-t-2___pSovg {
  margin-top: 2px !important;
}

.SocialHistory-module__m-t-3___wzomC {
  margin-top: 3px !important;
}

.SocialHistory-module__m-t-4___HLZoO {
  margin-top: 4px !important;
}

.SocialHistory-module__m-t-5___qgchf {
  margin-top: 5px !important;
}

.SocialHistory-module__m-t-8___z995G {
  margin-top: 8px !important;
}

.SocialHistory-module__m-t-10____V6tz {
  margin-top: 10px !important;
}

.SocialHistory-module__m-t-15___bMm1H {
  margin-top: 15px !important;
}

.SocialHistory-module__m-t-16___j4DIe {
  margin-top: 16px !important;
}

.SocialHistory-module__m-t-20___D_JQ8 {
  margin-top: 20px !important;
}

.SocialHistory-module__m-t-22___mGeJ6 {
  margin-top: 22px !important;
}

.SocialHistory-module__m-t-30___L9wjW {
  margin-top: 30px !important;
}

.SocialHistory-module__m-t-32___NctEx {
  margin-top: 32px !important;
}

.SocialHistory-module__m-l-auto___FC6Zz {
  margin-left: auto !important;
}

.SocialHistory-module__m-l-4___jkltR {
  margin-left: 4px !important;
}

.SocialHistory-module__m-l-5___W3PX_ {
  margin-left: 5px !important;
}

.SocialHistory-module__m-l-6___j75p2 {
  margin-left: 6px !important;
}

.SocialHistory-module__m-l-8___gsYm7 {
  margin-left: 8px !important;
}

.SocialHistory-module__m-l-10___cTGgM {
  margin-left: 10px !important;
}

.SocialHistory-module__m-l-16___TdJ7l {
  margin-left: 16px !important;
}

.SocialHistory-module__m-l-20___DVFa_ {
  margin-left: 20px !important;
}

.SocialHistory-module__m-l-24___IlSR9 {
  margin-left: 24px !important;
}

.SocialHistory-module__m-l-30___5agIM {
  margin-left: 30px !important;
}

.SocialHistory-module__m-l-35___TGCgn {
  margin-left: 35px !important;
}

.SocialHistory-module__m-l-40___DB51W {
  margin-left: 40px !important;
}

.SocialHistory-module__m-r-8___sWIqy {
  margin-right: 8px !important;
}

.SocialHistory-module__m-r-10___dZUFa {
  margin-right: 10px !important;
}

.SocialHistory-module__m-r-16___k9mfx {
  margin-right: 16px !important;
}

.SocialHistory-module__m-r-20___nT3Vv {
  margin-right: 20px !important;
}

.SocialHistory-module__m-r-24___R25fF {
  margin-right: 24px !important;
}

.SocialHistory-module__m-r-30___K22XB {
  margin-right: 30px !important;
}

.SocialHistory-module__m-r-40___XhMzk {
  margin-right: 40px !important;
}

.SocialHistory-module__border-r-3___Vaw5D {
  border-radius: 3px !important;
}

.SocialHistory-module__border-r-4___Q3x1l {
  border-radius: 4px !important;
}

.SocialHistory-module__border-r-6___Y_YrH {
  border-radius: 6px !important;
}

.SocialHistory-module__border-r-10___B_ig0 {
  border-radius: 10px !important;
}

.SocialHistory-module__border-r-12___Ls3U3 {
  border-radius: 12px !important;
}

.SocialHistory-module__border-r-16___CG45A {
  border-radius: 16px !important;
}

.SocialHistory-module__border-r-50___FZmpy {
  border-radius: 50% !important;
}

.SocialHistory-module__primary-border___z25ZR {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SocialHistory-module__primary-border-b___K5lwO {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SocialHistory-module__primary-border-t___d8X_1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SocialHistory-module__primary-border-l___gkWTD {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SocialHistory-module__primary-border-r___IBmtv {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SocialHistory-module__secondary-border___fbhZp {
  border: 1px solid #637768;
}

.SocialHistory-module__secondary-border-b___Lc1Re {
  border-bottom: 1px solid #637768;
}

.SocialHistory-module__secondary-border-t___wHZd2 {
  border-top: 1px solid #637768;
}

.SocialHistory-module__secondary-border-l___XugSk {
  border-left: 1px solid #637768;
}

.SocialHistory-module__secondary-border-r___JJOji {
  border-right: 1px solid #637768;
}

.SocialHistory-module__gap-0___CCZqu {
  gap: 0 !important;
}

.SocialHistory-module__gap-2___mUQ4v {
  gap: 2px !important;
}

.SocialHistory-module__gap-4___WOtNA {
  gap: 4px !important;
}

.SocialHistory-module__gap-5___WM6G3 {
  gap: 5px !important;
}

.SocialHistory-module__gap-6___AfBVm {
  gap: 6px !important;
}

.SocialHistory-module__gap-8___b7jvf {
  gap: 8px !important;
}

.SocialHistory-module__gap-10___MY5cD {
  gap: 10px !important;
}

.SocialHistory-module__gap-12____WQju {
  gap: 12px !important;
}

.SocialHistory-module__gap-14___CuLld {
  gap: 14px !important;
}

.SocialHistory-module__gap-16___vNOQK {
  gap: 16px !important;
}

.SocialHistory-module__gap-18___QcEmu {
  gap: 18px !important;
}

.SocialHistory-module__gap-20___I4R2W {
  gap: 20px !important;
}

.SocialHistory-module__gap-24___KhCZ_ {
  gap: 24px !important;
}

.SocialHistory-module__gap-26___HMkF1 {
  gap: 26px !important;
}

.SocialHistory-module__gap-30___ey4nk {
  gap: 30px !important;
}

.SocialHistory-module__gap-32___kwGjv {
  gap: 32px !important;
}

.SocialHistory-module__gap-40___ifs0O {
  gap: 40px !important;
}

.SocialHistory-module__gap-50___F0pw8 {
  gap: 50px !important;
}

.SocialHistory-module__flex-1___jdKa8 {
  flex: 1;
}

.SocialHistory-module__flex-none___zpks0 {
  flex: none !important;
}

.SocialHistory-module__flex-column___YFmRN {
  display: flex;
  flex-direction: column !important;
}

.SocialHistory-module__flex-row___GKNZd {
  display: flex;
  flex-direction: row !important;
}

.SocialHistory-module__vertically-centered___QniVO {
  display: flex;
  align-items: center !important;
}

.SocialHistory-module__horizontally-centered___HRAGF {
  display: flex;
  justify-content: center !important;
}

.SocialHistory-module__horizontally-end___cxruJ {
  display: flex;
  justify-content: end !important;
}

.SocialHistory-module__vertically-start___Hpe92 {
  display: flex;
  align-items: start !important;
}

.SocialHistory-module__space-between___YVNus {
  display: flex;
  justify-content: space-between !important;
}

.SocialHistory-module__flex-wrap___rZw6u {
  flex-wrap: wrap !important;
}

.SocialHistory-module__height-100___MhVnv {
  height: 100%;
}

.SocialHistory-module__width-50___VtK3X {
  width: 50% !important;
}

.SocialHistory-module__width-100___ZEzr7 {
  width: 100%;
}

.SocialHistory-module__cursor-pointer___japGJ {
  cursor: pointer;
}

.SocialHistory-module__cursor-not-allowed___uKieX {
  cursor: not-allowed !important;
}

.SocialHistory-module__absolute-centered___v2RSc {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SocialHistory-module__absolute___zbvB5 {
  position: absolute;
}

.SocialHistory-module__relative___JGpu0 {
  position: relative;
}

.SocialHistory-module__fixed___j38pt {
  position: fixed;
}

.SocialHistory-module__visible___t8a_U {
  opacity: 1;
}

.SocialHistory-module__invisible___AzBQx {
  opacity: 0;
}

.SocialHistory-module__col-90___F1aFN {
  width: 90% !important;
}

.SocialHistory-module__col-auto___sGlTU {
  width: auto !important;
}

.SocialHistory-module__medical-tabs___yqlyL {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SocialHistory-module__medical-table-new___Y_GjM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SocialHistory-module__medical-table-new___Y_GjM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SocialHistory-module__medical-table-new___Y_GjM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SocialHistory-module__medical-table-new___Y_GjM::-webkit-scrollbar-track {
  display: none;
}
.SocialHistory-module__medical-table-new___Y_GjM.SocialHistory-module__no-pagination___TbJuf {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SocialHistory-module__medical-table-new___Y_GjM.SocialHistory-module__no-pagination___TbJuf:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SocialHistory-module__medical-table-new___Y_GjM.SocialHistory-module__no-pagination___TbJuf::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SocialHistory-module__medical-table-new___Y_GjM.SocialHistory-module__no-pagination___TbJuf::-webkit-scrollbar-track {
  display: none;
}

.SocialHistory-module__medical-table-empty___sVqNM {
  padding: 14px 40px !important;
}

.SocialHistory-module__icon-btn___WJEk2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SocialHistory-module__search-icon___dtYe1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SocialHistory-module__disable-select___bVDFK {
  user-select: none;
}

.SocialHistory-module__break-word___i_0yj {
  word-break: break-word;
}

.SocialHistory-module__popup-clear-btn___oIGVi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SocialHistory-module__scroll-m-b-20___qbZOF {
  scroll-margin-bottom: 20px;
}

.SocialHistory-module__grid___cCfJ0 {
  display: grid;
  column-gap: 16px;
  margin-bottom: 6px;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
}
.SocialHistory-module__grid___cCfJ0 .SocialHistory-module__width50___PnywQ {
  grid-column: 2 span;
}
.SocialHistory-module__grid___cCfJ0 .SocialHistory-module__width100___evgYJ {
  grid-column: 3 span;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Social/forms/SocialHistory/SocialHistory.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;AA3pBE;EACE,mBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  column-gap: 16px;\n  margin-bottom: 6px;\n  align-items: center;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width50 {\n    grid-column: 2 span;\n  }\n\n  .width100 {\n    grid-column: 3 span;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SocialHistory-module__font-s-10___Zev0b`,
	"fontS12": `SocialHistory-module__font-s-12___jcqRU`,
	"fontS13": `SocialHistory-module__font-s-13___p7ouF`,
	"fontS14": `SocialHistory-module__font-s-14___eawHq`,
	"fontS15": `SocialHistory-module__font-s-15___W0Qxf`,
	"fontS16": `SocialHistory-module__font-s-16___AdtiL`,
	"fontS18": `SocialHistory-module__font-s-18___N3Iwv`,
	"fontS20": `SocialHistory-module__font-s-20___R0v2K`,
	"fontS22": `SocialHistory-module__font-s-22___zFo1M`,
	"fontS28": `SocialHistory-module__font-s-28___d4XMZ`,
	"fontW400": `SocialHistory-module__font-w-400___PJq7H`,
	"fontW500": `SocialHistory-module__font-w-500___dUeXe`,
	"fontW600": `SocialHistory-module__font-w-600___OPY9C`,
	"fontW700": `SocialHistory-module__font-w-700___rcks4`,
	"p5": `SocialHistory-module__p-5___FakV9`,
	"p12": `SocialHistory-module__p-12___AUps8`,
	"p16": `SocialHistory-module__p-16___RTLFt`,
	"p30": `SocialHistory-module__p-30___wrdiN`,
	"pB0": `SocialHistory-module__p-b-0___fy6Av`,
	"pB5": `SocialHistory-module__p-b-5___dWDxD`,
	"pB10": `SocialHistory-module__p-b-10___cewEV`,
	"pB12": `SocialHistory-module__p-b-12___NCCgQ`,
	"pB16": `SocialHistory-module__p-b-16___o4DF9`,
	"pB18": `SocialHistory-module__p-b-18___ApFmU`,
	"pB20": `SocialHistory-module__p-b-20___TtpF0`,
	"pB25": `SocialHistory-module__p-b-25___DON2T`,
	"pB30": `SocialHistory-module__p-b-30___XBaS2`,
	"pB50": `SocialHistory-module__p-b-50___q4fXa`,
	"pT0": `SocialHistory-module__p-t-0____OvOA`,
	"pT12": `SocialHistory-module__p-t-12___NKslD`,
	"pT16": `SocialHistory-module__p-t-16___fx55a`,
	"pT18": `SocialHistory-module__p-t-18___kZVPt`,
	"pT20": `SocialHistory-module__p-t-20___DJKkW`,
	"pT30": `SocialHistory-module__p-t-30___j8iBq`,
	"pT40": `SocialHistory-module__p-t-40___elYLN`,
	"pT50": `SocialHistory-module__p-t-50___rbcBV`,
	"pL20": `SocialHistory-module__p-l-20___SidPz`,
	"pL30": `SocialHistory-module__p-l-30___ODQgF`,
	"pL40": `SocialHistory-module__p-l-40___KToLT`,
	"pR16": `SocialHistory-module__p-r-16___CguAf`,
	"pR20": `SocialHistory-module__p-r-20___IQS84`,
	"pR30": `SocialHistory-module__p-r-30___y_dIU`,
	"pR50": `SocialHistory-module__p-r-50___PCuf1`,
	"pR60": `SocialHistory-module__p-r-60___Yneof`,
	"mB1": `SocialHistory-module__m-b-1___JaHwO`,
	"mB2": `SocialHistory-module__m-b-2___teU17`,
	"mB6": `SocialHistory-module__m-b-6___FhGCc`,
	"mB8": `SocialHistory-module__m-b-8___kxBKj`,
	"mB10": `SocialHistory-module__m-b-10___vy7E2`,
	"mB14": `SocialHistory-module__m-b-14___aA2u3`,
	"mB16": `SocialHistory-module__m-b-16___rwlcE`,
	"mB20": `SocialHistory-module__m-b-20___YLFqu`,
	"mB22": `SocialHistory-module__m-b-22___bmI5W`,
	"mB24": `SocialHistory-module__m-b-24___VQAee`,
	"mB30": `SocialHistory-module__m-b-30___XjZOM`,
	"mB32": `SocialHistory-module__m-b-32___Nb0eY`,
	"mB40": `SocialHistory-module__m-b-40___AdX3F`,
	"mT2": `SocialHistory-module__m-t-2___pSovg`,
	"mT3": `SocialHistory-module__m-t-3___wzomC`,
	"mT4": `SocialHistory-module__m-t-4___HLZoO`,
	"mT5": `SocialHistory-module__m-t-5___qgchf`,
	"mT8": `SocialHistory-module__m-t-8___z995G`,
	"mT10": `SocialHistory-module__m-t-10____V6tz`,
	"mT15": `SocialHistory-module__m-t-15___bMm1H`,
	"mT16": `SocialHistory-module__m-t-16___j4DIe`,
	"mT20": `SocialHistory-module__m-t-20___D_JQ8`,
	"mT22": `SocialHistory-module__m-t-22___mGeJ6`,
	"mT30": `SocialHistory-module__m-t-30___L9wjW`,
	"mT32": `SocialHistory-module__m-t-32___NctEx`,
	"mLAuto": `SocialHistory-module__m-l-auto___FC6Zz`,
	"mL4": `SocialHistory-module__m-l-4___jkltR`,
	"mL5": `SocialHistory-module__m-l-5___W3PX_`,
	"mL6": `SocialHistory-module__m-l-6___j75p2`,
	"mL8": `SocialHistory-module__m-l-8___gsYm7`,
	"mL10": `SocialHistory-module__m-l-10___cTGgM`,
	"mL16": `SocialHistory-module__m-l-16___TdJ7l`,
	"mL20": `SocialHistory-module__m-l-20___DVFa_`,
	"mL24": `SocialHistory-module__m-l-24___IlSR9`,
	"mL30": `SocialHistory-module__m-l-30___5agIM`,
	"mL35": `SocialHistory-module__m-l-35___TGCgn`,
	"mL40": `SocialHistory-module__m-l-40___DB51W`,
	"mR8": `SocialHistory-module__m-r-8___sWIqy`,
	"mR10": `SocialHistory-module__m-r-10___dZUFa`,
	"mR16": `SocialHistory-module__m-r-16___k9mfx`,
	"mR20": `SocialHistory-module__m-r-20___nT3Vv`,
	"mR24": `SocialHistory-module__m-r-24___R25fF`,
	"mR30": `SocialHistory-module__m-r-30___K22XB`,
	"mR40": `SocialHistory-module__m-r-40___XhMzk`,
	"borderR3": `SocialHistory-module__border-r-3___Vaw5D`,
	"borderR4": `SocialHistory-module__border-r-4___Q3x1l`,
	"borderR6": `SocialHistory-module__border-r-6___Y_YrH`,
	"borderR10": `SocialHistory-module__border-r-10___B_ig0`,
	"borderR12": `SocialHistory-module__border-r-12___Ls3U3`,
	"borderR16": `SocialHistory-module__border-r-16___CG45A`,
	"borderR50": `SocialHistory-module__border-r-50___FZmpy`,
	"primaryBorder": `SocialHistory-module__primary-border___z25ZR`,
	"primaryBorderB": `SocialHistory-module__primary-border-b___K5lwO`,
	"primaryBorderT": `SocialHistory-module__primary-border-t___d8X_1`,
	"primaryBorderL": `SocialHistory-module__primary-border-l___gkWTD`,
	"primaryBorderR": `SocialHistory-module__primary-border-r___IBmtv`,
	"secondaryBorder": `SocialHistory-module__secondary-border___fbhZp`,
	"secondaryBorderB": `SocialHistory-module__secondary-border-b___Lc1Re`,
	"secondaryBorderT": `SocialHistory-module__secondary-border-t___wHZd2`,
	"secondaryBorderL": `SocialHistory-module__secondary-border-l___XugSk`,
	"secondaryBorderR": `SocialHistory-module__secondary-border-r___JJOji`,
	"gap0": `SocialHistory-module__gap-0___CCZqu`,
	"gap2": `SocialHistory-module__gap-2___mUQ4v`,
	"gap4": `SocialHistory-module__gap-4___WOtNA`,
	"gap5": `SocialHistory-module__gap-5___WM6G3`,
	"gap6": `SocialHistory-module__gap-6___AfBVm`,
	"gap8": `SocialHistory-module__gap-8___b7jvf`,
	"gap10": `SocialHistory-module__gap-10___MY5cD`,
	"gap12": `SocialHistory-module__gap-12____WQju`,
	"gap14": `SocialHistory-module__gap-14___CuLld`,
	"gap16": `SocialHistory-module__gap-16___vNOQK`,
	"gap18": `SocialHistory-module__gap-18___QcEmu`,
	"gap20": `SocialHistory-module__gap-20___I4R2W`,
	"gap24": `SocialHistory-module__gap-24___KhCZ_`,
	"gap26": `SocialHistory-module__gap-26___HMkF1`,
	"gap30": `SocialHistory-module__gap-30___ey4nk`,
	"gap32": `SocialHistory-module__gap-32___kwGjv`,
	"gap40": `SocialHistory-module__gap-40___ifs0O`,
	"gap50": `SocialHistory-module__gap-50___F0pw8`,
	"flex1": `SocialHistory-module__flex-1___jdKa8`,
	"flexNone": `SocialHistory-module__flex-none___zpks0`,
	"flexColumn": `SocialHistory-module__flex-column___YFmRN`,
	"flexRow": `SocialHistory-module__flex-row___GKNZd`,
	"verticallyCentered": `SocialHistory-module__vertically-centered___QniVO`,
	"horizontallyCentered": `SocialHistory-module__horizontally-centered___HRAGF`,
	"horizontallyEnd": `SocialHistory-module__horizontally-end___cxruJ`,
	"verticallyStart": `SocialHistory-module__vertically-start___Hpe92`,
	"spaceBetween": `SocialHistory-module__space-between___YVNus`,
	"flexWrap": `SocialHistory-module__flex-wrap___rZw6u`,
	"height100": `SocialHistory-module__height-100___MhVnv`,
	"width50": `SocialHistory-module__width-50___VtK3X`,
	"width100": `SocialHistory-module__width-100___ZEzr7`,
	"cursorPointer": `SocialHistory-module__cursor-pointer___japGJ`,
	"cursorNotAllowed": `SocialHistory-module__cursor-not-allowed___uKieX`,
	"absoluteCentered": `SocialHistory-module__absolute-centered___v2RSc`,
	"absolute": `SocialHistory-module__absolute___zbvB5`,
	"relative": `SocialHistory-module__relative___JGpu0`,
	"fixed": `SocialHistory-module__fixed___j38pt`,
	"visible": `SocialHistory-module__visible___t8a_U`,
	"invisible": `SocialHistory-module__invisible___AzBQx`,
	"col90": `SocialHistory-module__col-90___F1aFN`,
	"colAuto": `SocialHistory-module__col-auto___sGlTU`,
	"medicalTabs": `SocialHistory-module__medical-tabs___yqlyL`,
	"medicalTableNew": `SocialHistory-module__medical-table-new___Y_GjM`,
	"noPagination": `SocialHistory-module__no-pagination___TbJuf`,
	"medicalTableEmpty": `SocialHistory-module__medical-table-empty___sVqNM`,
	"iconBtn": `SocialHistory-module__icon-btn___WJEk2`,
	"searchIcon": `SocialHistory-module__search-icon___dtYe1`,
	"disableSelect": `SocialHistory-module__disable-select___bVDFK`,
	"breakWord": `SocialHistory-module__break-word___i_0yj`,
	"popupClearBtn": `SocialHistory-module__popup-clear-btn___oIGVi`,
	"scrollMB20": `SocialHistory-module__scroll-m-b-20___qbZOF`,
	"grid": `SocialHistory-module__grid___cCfJ0`,
	"width50": `SocialHistory-module__width50___PnywQ`,
	"width100": `SocialHistory-module__width100___evgYJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
